import axios from "axios";
import { loadUser, refreshToken } from "../redux/actions/auth.actions";
import store from "../redux/store";
import { jwtDecode } from "jwt-decode";

const axiosInstance =  axios.create();

function jwtWillExpireSoon(token) {
    try {
        const decodedToken =  jwtDecode(token);
        if (decodedToken && decodedToken.exp) {
            const expiryTime =  decodedToken.exp;

            // Calculate the current time in Unix timestamp format
            const currentTime = Math.floor(Date.now() / 1000);
            // Calculate the time 1 hour from now in Unix timestamp format
            const oneHourFromNow = currentTime + 3600 // 3600 seconds = 1 hour

            // Check if the given Unix timestamp is less than one hour from now
            const willExpireWithinOneHour = expiryTime < oneHourFromNow;
            return willExpireWithinOneHour;
        } else {
            return false; // Token does not have an expiration time
        }
    } catch (error) {
        console.error('Error decoding token:', error);
        return false;
    }
}

axiosInstance.interceptors.request.use(
    async (config) =>{
        // get the token from your storage
        const accessToken = localStorage.getItem("accessToken");
        const store_data = store.getState();

        // verify the token before making the request
        if(accessToken){
            if(jwtWillExpireSoon(accessToken)){
                // refresh token
                if(!store_data?.authReducer?.refresh_token_loading){
                    store.dispatch(refreshToken());
                }
            }
        }
        return config;
    },
    (error)=>{
        return Promise.reject(error);
    }
)

export default axiosInstance;